import * as types from "../../Action/actionTypes"

const initialState = {
  creators:           [],
  creatorsLoading:    false,
  creatorsError:      null,

  invitations:        [],
  invitationsLoading: false,
  invitationsError:   null,

  sendingInvite:      false,
  sendInviteError:    null,

  // keyed by campaign_id for quick lookup
  assignmentsByCampaign: {},
  assignmentsLoading:    false,
  savingAssignments:     false,
  reviewingAssignment:   false,
  submittingToBrandIds:  [],  // set of assignment IDs currently being submitted
}

const agencyReducer = (state = initialState, action) => {
  switch (action.type) {

    case types.FETCH_AGENCY_CREATORS_START:
      return { ...state, creatorsLoading: true, creatorsError: null }
    case types.FETCH_AGENCY_CREATORS_SUCCESS:
      return { ...state, creatorsLoading: false, creators: action.payload.creators || [] }
    case types.FETCH_AGENCY_CREATORS_ERROR:
      return { ...state, creatorsLoading: false, creatorsError: action.payload }

    case types.FETCH_AGENCY_INVITATIONS_START:
      return { ...state, invitationsLoading: true, invitationsError: null }
    case types.FETCH_AGENCY_INVITATIONS_SUCCESS:
      return { ...state, invitationsLoading: false, invitations: action.payload.invitations || [] }
    case types.FETCH_AGENCY_INVITATIONS_ERROR:
      return { ...state, invitationsLoading: false, invitationsError: action.payload }

    case types.SEND_INVITATION_START:
      return { ...state, sendingInvite: true, sendInviteError: null }
    case types.SEND_INVITATION_SUCCESS:
      return {
        ...state,
        sendingInvite: false,
        invitations: [action.payload.invitation, ...state.invitations],
      }
    case types.SEND_INVITATION_ERROR:
      return { ...state, sendingInvite: false, sendInviteError: action.payload }

    case types.FETCH_CAMPAIGN_ASSIGNMENTS_START:
      return { ...state, assignmentsLoading: true }
    case types.FETCH_CAMPAIGN_ASSIGNMENTS_SUCCESS:
      return {
        ...state,
        assignmentsLoading: false,
        assignmentsByCampaign: {
          ...state.assignmentsByCampaign,
          [action.payload.campaignId]: action.payload.assignments,
        },
      }
    case types.FETCH_CAMPAIGN_ASSIGNMENTS_ERROR:
      return { ...state, assignmentsLoading: false }

    case types.SAVE_CAMPAIGN_ASSIGNMENTS_START:
      return { ...state, savingAssignments: true }
    case types.SAVE_CAMPAIGN_ASSIGNMENTS_SUCCESS:
      return {
        ...state,
        savingAssignments: false,
        assignmentsByCampaign: {
          ...state.assignmentsByCampaign,
          [action.payload.campaignId]: action.payload.assignments,
        },
      }
    case types.SAVE_CAMPAIGN_ASSIGNMENTS_ERROR:
      return { ...state, savingAssignments: false }

    case types.REVIEW_ASSIGNMENT_START:
      return { ...state, reviewingAssignment: true }
    case types.REVIEW_ASSIGNMENT_SUCCESS: {
      const updated = action.payload
      const cid = String(updated.campaign_id)
      const existing = state.assignmentsByCampaign[cid] || []
      return {
        ...state,
        reviewingAssignment: false,
        assignmentsByCampaign: {
          ...state.assignmentsByCampaign,
          [cid]: existing.map((a) => a.id === updated.id ? { ...a, ...updated } : a),
        },
      }
    }
    case types.REVIEW_ASSIGNMENT_ERROR:
      return { ...state, reviewingAssignment: false }

    case types.SUBMIT_TO_BRAND_START:
      return { ...state, submittingToBrandIds: [...state.submittingToBrandIds, action.payload] }
    case types.SUBMIT_TO_BRAND_SUCCESS: {
      const updated = action.payload
      const cid     = String(updated.campaign_id)
      const existing = state.assignmentsByCampaign[cid] || []
      return {
        ...state,
        submittingToBrandIds: state.submittingToBrandIds.filter((id) => id !== updated.id),
        assignmentsByCampaign: {
          ...state.assignmentsByCampaign,
          [cid]: existing.map((a) => a.id === updated.id ? { ...a, ...updated } : a),
        },
      }
    }
    case types.SUBMIT_TO_BRAND_ERROR:
      return { ...state, submittingToBrandIds: [] }

    case types.REMOVE_ROSTER_CREATOR_SUCCESS: {
      const targetId = action.payload.creatorId || action.payload.creator_id
      return {
        ...state,
        creators: state.creators.filter((c) => String(c.id) !== String(targetId)),
      }
    }

    case types.CANCEL_AGENCY_INVITE_SUCCESS: {
      const targetId = action.payload.invitationId || action.payload.invitation_id
      return {
        ...state,
        invitations: state.invitations.filter((inv) => String(inv.id) !== String(targetId)),
      }
    }

    default:
      return state
  }
}

export default agencyReducer
